/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CBasketStatus {
    SENT = 'Sent',
    SOLD = 'Sold',
    CANCELLED = 'Cancelled',
}
